import React from 'react';
import c from 'classnames';
import Button from '../../../Button';
import PlusIcon from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import s from './PlusIconWithTextButton.scss';
export var PlusIconWithTextButton = function (_a) {
    var withCoreBanner = _a.withCoreBanner, buttonView = _a.buttonView, disabled = _a.disabled, text = _a.text, href = _a.href, onClick = _a.onClick;
    return (React.createElement(Button, { view: buttonView || 'b14', height: "medium", onClick: onClick, href: href, disabled: disabled, className: s['button'] },
        withCoreBanner && React.createElement(CoreBadge, { size: "large" }),
        React.createElement(PlusIcon, { className: c(s['plus-icon'], disabled && s['disabled-icon']), size: IconSize.SMALL }),
        text));
};
PlusIconWithTextButton.displayName = 'PlusIconWithTextButton';
export default PlusIconWithTextButton;
//# sourceMappingURL=PlusIconWithTextButton.js.map